<template>
  <div
    class="custom-animation tw-relative tw-bg-white tw-rounded tw-border tw-border-1 tw-border-solid tw-border-[#EFF0F1] tw-shadow-[0px_0px_4px_0px_rgba(0,0,0,0.05)]"
  >
    <div
      id="dash-vendor-assessment-card-title"
      class="tw-h-[66px] tw-rounded-t tw-flex tw-justify-between tw-items-center tw-bg-[#FCFCFD] tw-py-[25px] tw-px-[20px] tw-border-b-[1px] tw-border-0 tw-border-solid tw-border-[#EFF0F1]"
    >
      <div class="tw-flex tw-gap-[10px]">
        <span class="tw-text-[#211F58] tw-text-[18px] tw-font-semibold">
          {{ getComponentUiText("app-dashboard-vendor-assessment-title-1") }}
        </span>
      </div>
    </div>
    <div
      class="vendor-ass-card-body tw-grid tw-grid-cols-1 tw-gap-[20px] tw-p-[25px]"
    >
      <div
        v-if="isLoading"
        class="custom-global-skeleton tw-p-[20px] tw-h-[112px]"
      ></div>
      <DummyCard
        v-if="!isLoading && !sortVendorAssessmentCard.length"
        :title="getComponentUiText('app-dashboard-dummy-title-vendor-ass-1')"
        :title-button="
          getComponentUiText('app-dashboard-dummy-button-title-vendor-ass-1')
        "
        :title-class="'tw-w-[322px]'"
        :custom-class="'tw-top-[67px]'"
        @button:click="() => emits('button:click')"
      />
      <div v-for="(item, index) in sortVendorAssessmentCard" :key="index">
        <DashboardVendorAssessmentCard :data="item" />
      </div>
    </div>

    <div
      v-if="!isLoading && !sortVendorAssessmentCard.length"
      class="vendor-ass-card-body tw-grid tw-grid-cols-1 tw-gap-[20px] tw-p-[25px]"
    >
      <div
        v-if="isLoading"
        class="custom-global-skeleton tw-p-[20px] tw-h-[112px]"
      ></div>
      <DummyCard
        v-if="!isLoading && !sortVendorAssessmentCard.length"
        :title="getComponentUiText('app-dashboard-dummy-title-vendor-ass-1')"
        :title-button="
          getComponentUiText('app-dashboard-dummy-button-title-vendor-ass-1')
        "
        :title-class="'tw-w-[322px]'"
        :custom-class="'tw-top-[67px]'"
        @button:click="() => emits('button:click')"
      />
      <div v-for="(item, index) in fakeData" :key="index">
        <DashboardVendorAssessmentCard :data="item" />
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import { computed, onMounted, PropType, ref, watch } from "vue";
import { getComponentUiText } from "@/utils/utilities";
import DashboardVendorAssessmentCard from "./dashboardVendorAssessmentCard.vue";
import { IChecklistRequested } from "@/interfaces/vendor";
import store from "@/store";
import DummyCard from "./dummyCard.vue";

const checklistDetailData = computed(
  () => store.state.Vendor.requestedChecklist,
);
const sortVendorAssessmentCard = ref<IChecklistRequested[]>([]);

const emits = defineEmits(["button:click"]);
const isLoading = ref(true);

watch(
  checklistDetailData,
  (newValue) => {
    sortVendorAssessmentCard.value = [...newValue].sort(
      (a, b) => (b.scorePcnt ?? 0) - (a.scorePcnt ?? 0),
    );
  },
  { immediate: true },
);

onMounted(async () => {
  isLoading.value = true;
  await store.dispatch("Vendor/fetchRequestedChecklist", {
    isArchived: false,
  });
  isLoading.value = false;
});

const fakeData = [
  {
    checklistRequestedId: 1,
    checklistRequestedHistory: [],
    providerName: "abc",
    scorePcnt: 0.5,
    status: "Completed",
    name: "test",
    dateUpdated: "12/12/2022",
  },
  {
    checklistRequestedId: 2,
    checklistRequestedHistory: [],
    providerName: "abc",
    scorePcnt: 0.75,
    status: "Completed",
    name: "test",
    dateUpdated: "12/12/2022",
  },
  {
    checklistRequestedId: 3,
    checklistRequestedHistory: [],
    providerName: "abc",
    scorePcnt: 0.45,
    status: "Completed",
    name: "test",
    dateUpdated: "12/12/2022",
  },
  {
    checklistRequestedId: 3,
    checklistRequestedHistory: [],
    providerName: "abc",
    scorePcnt: 0.35,
    status: "Completed",
    name: "test",
    dateUpdated: "12/12/2022",
  },
];
</script>

<style scoped>
.default {
  background: var(--ui-white, #fff);
  color: var(--ui-dark-grey, #878787);
  border-radius: 4px;
  border: 1px solid var(--ui-rule, #eff0f1);
}
@media screen and (min-width: 1920px) {
  .vendor-ass-card-body {
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }
}
</style>
